import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'

export const useGetCurrentShopID = () => {
  return useSelector((state: IRootReducerState) => state.auth.shop.ID)
}

export const useGetCurrentShopName = () => {
  return useSelector((state: IRootReducerState) => state.auth.shop.Name)
}

export const useGetCurrentOrderConfirmationEmail = () => {
  return useSelector((state: IRootReducerState) => state.auth.shop.OrderConfirmationEmailAddress)
}
